"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyReviewInsightsModuleAccess = void 0;
// gives access to legacy review insights module holders
exports.legacyReviewInsightsModuleAccess = [
    {
        entitlement: "Insights_Sentiment",
    },
    {
        launchDarkly: "b2b-sentiment-app-review-insights",
    },
];
//# sourceMappingURL=review-insights.js.map